import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export interface VehicleFinancialSummary {
  vehicle: { id: string; plate: string }
  period: { startDate: string | null; endDate: string | null }
  freights: {
    count: number
    totalRevenue: string
    totalDriverPay: string
    grossMargin: string
  }
  expenses: {
    count: number
    total: string
    byCategory: Array<{
      categoryId: string
      categoryName: string
      total: string
      count: number
    }>
  }
  netResult: string
}

export interface VehicleFinancialSummaryParams {
  startDate?: string
  endDate?: string
}

export function useVehicleFinancialSummary(
  vehicleId: string,
  params: VehicleFinancialSummaryParams = {},
) {
  return useQuery({
    queryKey: ['vehicles', vehicleId, 'financial-summary', params],
    queryFn: () =>
      api
        .get<VehicleFinancialSummary>(`/vehicles/${vehicleId}/financial-summary`, { params })
        .then((r) => r.data),
    enabled: !!vehicleId,
  })
}
